import KitAPI from "../KitAPI";
import KitLog from "../KitLog";
import { KitSp } from "../KitSp";
import { KitTrack } from "../Track/KitTrack";
import { ABEntity } from "./ABEntity";
import KitAB from "./KitAB";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {EventName} from "@/Fwk/Kit/Track/TrackConst";

export class Constants {
    static DATA_ETAG = "etag";
    static TIMESTAMP = "timestamp";
    static CODE = "code";
    static MESSAGE = "message";
    static DATA = "data";
    static MATCH_AB_EXPERIMENT = "match_ab_experiment";
    static AB_EXPERIMENT_DATA = "ab_experiment_data";
    static AB_TYPE = "ab_type";
    static AB_TYPE_CROSS = "cross";
    static AB_TYPE_NON_CROSS = "non-cross";
    static AB_ID = "ab_id";
    static AB_GROUP_ID = "ab_group_id";
    static AB_NAME = "ab_name";
    static AB_GROUP_NAME = "ab_group_name";
    static VARIABLES = "variables";
    static PARAM_KEY = "param_key";
    static PARAM_VALUE = "param_value";
    static COUNTRY = "country";
}

    /// <summary>
    /// AB缓存相关
    /// </summary>
    /// <author>xiexingwu</author>
    export class AbCacher
    {
        private static PREFS_KEY = "ab_";
        private static CACHE_KEY = this.PREFS_KEY + "cache";
        private static GOT_DATA_TIME = this.PREFS_KEY + "time4GotData";
        private static LOCAL_GOT_DATA_TIME = this.PREFS_KEY + "localGotDataTime";
        private static ELAPSED_REAL_TIME = this.PREFS_KEY + "elapsedRealtime";
        private static ENTER_APP_COUNT = this.PREFS_KEY + "enterAppCount";
        private static REQUEST_COUNT = this.PREFS_KEY + "requestCount";
        private static SYS_USER_ID = this.PREFS_KEY + "sys_user_id";
        private static LAST_LOAD_DAY = this.PREFS_KEY + "last_load_day";

        private static _entity: ABEntity;

        //获取到配置的服务器时间
        static lastGotDataTime: number = 0;

        //获取到配置的本地时间
        static lastLocalGotDataTime = 0;
        static elapsedRealtime = 0;
        static enterAppCount = 1;
        static Constants: any;

        static Init() {
            this.lastGotDataTime = KitSp.GetInt(this.GOT_DATA_TIME, -1)
            this.lastLocalGotDataTime = KitSp.GetInt(this.LOCAL_GOT_DATA_TIME, -1)
            this.elapsedRealtime = KitSp.GetInt(this.ELAPSED_REAL_TIME, -1)
            this.enterAppCount = KitSp.GetInt(this.ENTER_APP_COUNT, 0)
            this.enterAppCount += 1;
            KitSp.SetInt(this.ENTER_APP_COUNT, this.enterAppCount);
            KitSp.Apply();

            if (KitLog.IsLog) KitAB.Log(`记录到第 ${this.enterAppCount} 次冷启动进入App`);

            if (this.enterAppCount == 1)
            {
                if (KitLog.IsLog) KitAB.Log("设备首次激活");
                KitTrack.TrackALive(EventName.ACTIVE);
            }

            const cs = this.GetData();
            if (cs)
            {
                this._entity = new ABEntity();
                return;
            }

            try
            {
                const jb = new JsonData(null, cs);
                if (jb != null && jb.Count > 0)
                {
                    this._entity = new ABEntity();
                    this.BuildEntity(jb, this._entity,"AB缓存");
                    return;
                }
            }
            catch (Exception)
            {
            }

            this._entity = new ABEntity();
        }

        static GetEntity(): ABEntity {
            return this._entity;
        }

        static SetEntity(entity: ABEntity) {
            this._entity = entity;
        }

        private static GetData(): string {
            return KitSp.GetString(this.CACHE_KEY, "");
        }

        private static Save(time: number, json: string = "")
        {
            if (KitLog.IsLog) KitAB.Log(`存储下发配置 ${json},服务器时间：${time}`);
            if (json) KitSp.SetString(this.CACHE_KEY, json);
            
            //保存最后一次从网络获得配置的时间
            if (time > 0)
            {
                this.lastGotDataTime = time * 1000;
                this.elapsedRealtime = KitAPI.ElapsedRealtime();
                this.lastLocalGotDataTime = KitAPI.GetNowMills();
                KitSp.SetInt(this.GOT_DATA_TIME, this.lastGotDataTime);
                KitSp.SetInt(this.LOCAL_GOT_DATA_TIME, this.lastLocalGotDataTime);
                KitSp.SetInt(this.ELAPSED_REAL_TIME, this.elapsedRealtime);
            }
            KitSp.Apply();
        }

        private static BuildEntity(dateJson: JsonData, bean: ABEntity, log: string) //AB缓存
        {
            if (dateJson == null) return;
            // const dateJson = new JsonData(data);
            try
            {
                bean.etag = dateJson.OptString(Constants.DATA_ETAG);
                bean.code = dateJson.OptString(Constants.CODE);
                bean.message = dateJson.OptString(Constants.MESSAGE);
                bean.timestamp = dateJson.OptLong(Constants.TIMESTAMP);
                let dataObject = dateJson.OptJsonData(Constants.DATA);

                if (dataObject == null){
                    dataObject = new JsonData(null, '{}');
                }
                if (KitLog.IsLog)
                {
                    KitAB.Log(`${log}时间=${bean.timestamp}`);
                    KitAB.Log(`${log}ETag：${bean.etag}`);
                    KitAB.Log(`${log}数据：${dataObject}`);
                }

                const abExperimentJsonArray = dataObject.OptJsonDataArray(Constants.AB_EXPERIMENT_DATA);

                var match_ab_experiment = dataObject.OptInt(Constants.MATCH_AB_EXPERIMENT);
                bean.match_ab_experiment = match_ab_experiment;
                bean.hadAbExperiment = match_ab_experiment > 0;

                if (abExperimentJsonArray != null && abExperimentJsonArray.length > 0 && bean.hadAbExperiment)
                {
                    bean.abExperimentData = abExperimentJsonArray;
                    const orthogonalMap = new JsonData();
                    for (let abExperiment of abExperimentJsonArray) {
                        // JsonData abExperiment = new JsonData(item);
                        const abType = abExperiment.OptString(Constants.AB_TYPE);

                        if (abType == Constants.AB_TYPE_CROSS)
                        {
                            // key：正交实验ID； value：正交实验对应的测试组ID
                            const abid = abExperiment.OptString(Constants.AB_ID);
                            const groupId = abExperiment.OptString(Constants.AB_GROUP_ID);
                            orthogonalMap.put(abid, groupId);
                        }
                        else if (abType == Constants.AB_TYPE_NON_CROSS)
                        {
                            bean.ab_id = abExperiment.OptString(Constants.AB_ID);
                            bean.ab_name = abExperiment.OptString(Constants.AB_NAME);
                            bean.ab_group_id = abExperiment.OptString(Constants.AB_GROUP_ID);
                            bean.ab_group_name = abExperiment.OptString(Constants.AB_GROUP_NAME);
                        }
                        else
                        {
                            KitAB.LogWarning("json2BaseDataEntity: abType is not match");
                        }
                    }

                    if (orthogonalMap.Count > 0)
                    {
                        bean.orthogonalMapStr = orthogonalMap.toString();
                    }
                }
                else
                {
                    bean.abExperimentData = null;
                    if (KitLog.IsLog) KitAB.Log("json2BaseDataEntity: 没有实验下发 或者 match_ab_experiment=0");
                }

                const variablesJsonArray = dataObject.OptJsonDataArray(Constants.VARIABLES);
                if (variablesJsonArray != null && variablesJsonArray.length > 0)
                {
                    for (let item of variablesJsonArray) {
                        if (item != null)
                        {
                            const key = item.OptString(Constants.PARAM_KEY);
                            const value = item.OptString(Constants.PARAM_VALUE);
                            bean.putDataString(key, value);
                            if (KitLog.IsLog) KitAB.Log(`${log}配置:${key}-${value}`);
                        }
                    }

                    bean.variables = variablesJsonArray.toString();
                }

                bean.country = dataObject.OptString(Constants.COUNTRY);
            } catch (e) {
                if (KitLog.IsLog) KitAB.Log(`${log}数据解析失败，${e}`);
            }
        }

        static ParseEntity(data: JsonData): ABEntity {
            const bean = new ABEntity();
            bean.fromEtag = "1";
            this.BuildEntity(data, bean, "AB下发");

            try {
                const oldEtag = this._entity.etag;
                const userCache = bean.etag && bean.etag == oldEtag;
                if (KitLog.IsLog) KitAB.Log(`当前etag=${bean.etag}, 本地etag=${oldEtag}`);
                if (userCache) {
                    if (KitLog.IsLog) KitAB.Log(`etag相同，使用本地缓存 etag=${bean.etag}`);
                    this.Save(bean.timestamp);
                    return this._entity;
                }
            } catch (e) {
                if (KitLog.IsLog) KitAB.LogWarning(`parseEntity 获取缓存ab值失败：${e}`);
                return this._entity;
            }

            this.Save(bean.timestamp, data.toString());
            return bean;
        }

        static GetRequestCount(): number {
            const dayOfYear = new Date().getDate();
            const day = KitSp.GetInt(this.LAST_LOAD_DAY, 0);
            if (day != dayOfYear) //每天重置次数
            {
                KitSp.SetInt(this.LAST_LOAD_DAY, dayOfYear);
                KitSp.SetInt(this.REQUEST_COUNT, 0);
                KitSp.Apply();
                return 0;
            }

            return KitSp.GetInt(this.REQUEST_COUNT, 0);
        }

        static AddRequestCount(): number {
            const count = KitSp.GetInt(this.PREFS_KEY + this.REQUEST_COUNT, 0) + 1;
            KitSp.SetInt(this.PREFS_KEY + this.REQUEST_COUNT, count);
            KitSp.Apply();
            return count;
        }


        static GetUserId(): string {
            return KitSp.GetString(this.PREFS_KEY + this.SYS_USER_ID, "");
        }

        static SetUserId(userId: string) {
            KitSp.SetString(this.PREFS_KEY + this.SYS_USER_ID, userId);
            KitSp.Apply();
        }
    }
